import React, { memo, useEffect } from "react";
import {
  ActionHistoryProps,
  ActionHistoryItem,
  ActionHistoryAction,
} from "../types";
import { COLORS } from "../constants";
import { formateDateWithTime } from "../hook/ScreenHelper";
import "../styles.css";

interface ExtendedActionHistoryProps extends ActionHistoryProps {
  processData?: ActionHistoryItem;
  actions?: ActionHistoryAction[];
  history: any;
  processId: number | "";
}

const ActionHistory: React.FC<ExtendedActionHistoryProps> = ({
  close,
  processData,
  actions,
  history,
  processId,
}) => {

  useEffect(() => {
    const scrollY = window.scrollY;

    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";

    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";

      window.scrollTo(0, scrollY);
    };
  }, []);

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
      style={{ background: "rgba(0,0,0,0.4)", zIndex: 9999 }}
    >
      <div
        className="bg-white p-3 rounded shadow"
        style={{
          width: "90%",
          maxWidth: "900px",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        {/* HEADER */}
        <div className="d-flex flex-row align-items-center justify-content-between">
          <h5 className="mb-0" style={{ color: COLORS.TEXT_PRIMARY }}>
            Action History
          </h5>

          <button className="btn d-flex p-2 text-dark" onClick={close}>
            <i
              className="bi bi-x-lg text-dark"
              style={{ color: COLORS.TEXT_PRIMARY }}
            ></i>
          </button>
        </div>

        <div className="container mt-2">
          <div className="table-wrapper">
            <table className="table text-center w-100 action-history-table table-border">
              {/* Shared column grid */}
              <colgroup>
                <col style={{ width: "25%" }} />
                <col style={{ width: "25%" }} />
                <col style={{ width: "25%" }} />
                <col style={{ width: "25%" }} />
              </colgroup>

              {/* ===== HEADER 1 ===== */}
              <thead
                className="table-head"
                style={{ background: COLORS.BG_LIGHTER }}
              >
                <tr style={{ color: COLORS.TEXT_MUTED }}>
                  <th>Process Number</th>
                  <th>Requested On</th>
                  <th>Requested By</th>
                  <th>Process Status</th>
                </tr>
              </thead>

              {/* ===== BODY 1 ===== */}
              <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "medium" }}>
                <tr>
                  <td>{processId}</td>
                  <td>
                    {formateDateWithTime(history?.latestStatus?.requestedOn)}
                  </td>
                  <td>{history?.latestStatus?.requestedBy}</td>
                  <td>{history?.latestStatus?.status}</td>
                </tr>
              </tbody>

              <br />
              <br />
              {/* ===== HEADER 2 ===== */}
              <thead
                className="table-head mt-3"
                style={{ background: COLORS.BG_LIGHTER }}
              >
                <tr style={{ color: COLORS.TEXT_MUTED }}>
                  <th>Action</th>
                  <th>Remarks</th>
                  <th>Actioner</th>
                  <th>Action On</th>
                </tr>
              </thead>

              {/* ===== BODY 2 ===== */}
              <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "medium" }}>
                {history?.actionHistory?.map((action, index) => (
                  <tr key={index}>
                    <td>{action.action}</td>
                    <td>{action.remark || '-'}</td>
                    <td>{action.actionBy}</td>
                    <td>{formateDateWithTime(action.actionDate)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* <div className="container mt-2">
          {history?.latestStatus && (
            <div style={{ overflowX: "auto" }}>
              <table className="table text-center table-border spaced-table w-100">
                <thead style={{ background: COLORS.BG_LIGHTER }}>
                  <tr style={{ color: COLORS.TEXT_MUTED }}>
                    <th>Process Number</th>
                    <th>Requested On</th>
                    <th>Requested By</th>
                    <th>Process Status</th>
                  </tr>
                </thead>
                <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "small" }}>
                  <tr>
                    <td>{processId}</td>
                    <td>{formateDate(history?.latestStatus?.requestedOn)}</td>
                    <td>{history?.latestStatus?.requestedBy}</td>
                    <td>{history?.latestStatus?.status}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          {history?.actionHistory && (
            <div style={{ overflowX: "auto" }}>
              <table className="table text-center table-border spaced-table w-100">
                <thead style={{ background: COLORS.BG_LIGHTER }}>
                  <tr style={{ color: COLORS.TEXT_MUTED }}>
                    <th>Action</th>
                    <th>Remarks</th>
                    <th>Actioner</th>
                    <th>Action On</th>
                  </tr>
                </thead>
                <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "small" }}>
                  {history?.actionHistory.map((action, index) => (
                    <tr key={index}>
                      <td>{action.action}</td>
                      <td>{action.remark}</td>
                      <td>{action.actionBy}</td>
                      <td>{formateDate(action.actionDate)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div> */}
      </div>
    </div>
  );
};

export default memo(ActionHistory);
